export default __webpack_public_path__ + "static/1689-e2639ff9e2e6ba8970601df399e0bce2.jpg";